<template>
  <v-row v-click-outside="onClickOutsideExpertComments" class="LKMunMehFormRow">
    <v-col cols="8">
      <div
        :class="{ 'LKMunMehFormRow__title': true, 'bold': bold }"
        v-text="`${index}. ${item.name}`"
      />
    </v-col>
    <v-col cols="4">
      <v-row>
        <v-col :cols="marksHidden ? 12 : 3" class="text-right">
          <div
            class="LKMunMehFormRow__title bold"
            v-text="item.max_score"
          />
        </v-col>
        <template v-if="!marksHidden">
          <v-col cols="3" class="text-right">
            <v-btn
              v-if="firstExpertComment"
              icon
              x-small
              style="margin-right: 4px; vertical-align: bottom;"
              @click="isExpertOneCommentShow = !isExpertOneCommentShow"
            >
              <v-icon v-text="'mdi-help-circle-outline'" />
            </v-btn>
            <LKMunMehViewComment
              v-if="isExpertOneCommentShow"
              class="commentExpertOne"
              :text-comment="firstExpertComment"
              @close="closeCommentExpertOne"
            />
            <div style="display: inline-block;">
              <div
                class="LKMunMehFormRow__title bold"
                v-text="getMarkForExpertOneLevel(item.id)"
              />
              <v-icon v-if="getColor1(item.id)" x-small :color="getColor1(item.id)" v-text="'mdi-circle'" />
            </div>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-btn
              v-if="secondExpertComment"
              icon
              x-small
              style="margin-right: 4px; vertical-align: bottom;"
              @click="isExpertTwoCommentShow = !isExpertTwoCommentShow"
            >
              <v-icon v-text="'mdi-help-circle-outline'" />
            </v-btn>
            <LKMunMehViewComment
              v-if="isExpertTwoCommentShow"
              class="commentExpertTwo"
              :text-comment="secondExpertComment"
              @close="closeCommentExpertTwo"
            />
            <div style="display: inline-block;">
              <div
                class="LKMunMehFormRow__title bold"
                v-text="getMarkForExpertTwoLevel(item.id)"
              />
              <v-icon v-if="getColor2(item.id)" x-small :color="getColor2(item.id)" v-text="'mdi-circle'" />
            </div>
          </v-col>
          <v-col cols="3" class="text-right">
            <div
              class="LKMunMehFormRow__title bold"
              v-text="getMarkForExpertThreeLevel(item.id)"
            />
            <v-icon v-if="getColor3(item.id)" x-small :color="getColor3(item.id)" v-text="'mdi-circle'" />
          </v-col>
        </template>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { toNumber } from 'lodash'
import variables from '@/assets/scss/exports.scss'
import { LKMunMehHostViewMapper as StoreMapper } from '../store'
import LKMunMehViewComment from './LKMunMehHostViewComment.vue'

export default {
  name: 'LKMunMehFormRow',
  components: {
    LKMunMehViewComment,
  },
  props: {
    value: {
      type: String,
      default: void 0,
    },
    item: {
      type: Object,
      required: true,
    },
    idx: {
      type: [String, Number],
      required: true,
    },
    bold: Boolean,
    marksHidden: Boolean,
  },
  data: () => ({
    isExpertOneCommentShow: false,
    isExpertTwoCommentShow: false,
  }),
  computed: {
    ...StoreMapper.mapGetters([
      'getMarkForExpertThreeLevel',
      'getMarkForExpertOneLevel',
      'getMarkForExpertTwoLevel',
      'getStatusForExpertOneLevel',
      'getStatusForExpertTwoLevel',
      'getStatusForExpertThreeLevel',
      'getExpertOneCommentForIndicator',
      'getExpertTwoCommentForIndicator',
    ]),
    firstExpertComment() {
      return this.getExpertOneCommentForIndicator(this.item.id)
    },
    secondExpertComment() {
      return this.getExpertTwoCommentForIndicator(this.item.id)
    },
    lazyValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    isInput() {
      return this.value !== void 0
    },
    color() {
      return this.item.is_filled ? variables['webflow-color-green'] : variables['color-gray']
    },
    index() {
      if (typeof this.idx === 'number') {
        return this.idx + 1
      }

      const indices = this.idx.split('.')
      return indices.map((el) => toNumber(el) + 1).join('.')
    },
  },
  watch: {
    'item.id': {
      async handler() {
        if (!this.isInput) {
          const { params } = this.$route
          const { munMehId, formId } = params
          const { item } = this
          await this.getLevelMarks({ munMehId, formId, parentLevel: item })
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...StoreMapper.mapActions(['getLevelMarks']),
    onClickOutsideExpertComments() {
      this.isExpertOneCommentShow = false
      this.isExpertTwoCommentShow = false
    },
    closeCommentExpertOne() {
      this.isExpertOneCommentShow = false
    },
    closeCommentExpertTwo() {
      this.isExpertTwoCommentShow = false
    },
    getColor1(id) {
      const result = this.getStatusForExpertOneLevel(id)
      return this.getColorByResult(result)
    },
    getColor2(id) {
      const result = this.getStatusForExpertTwoLevel(id)
      return this.getColorByResult(result)
    },
    getColor3(id) {
      const result = this.getStatusForExpertThreeLevel(id)
      return this.getColorByResult(result)
    },
    getColorByResult(result) {
      switch (result) {
        case 'not_started':
          return 'red'
        case 'in_progress':
          return '#ffc111'
        case 'done':
          return '#11ff20'
        default:
      }
      return null
    },
  },
}
</script>

<style lang="scss">
.LKMunMehFormRow {
  position: relative;

  &__title {
    font-size: 16px;
    font-weight: normal;
  }

  .bold {
    font-weight: bold;
  }

  .commentExpertOne {
    left: 0;
  }

  .commentExpertTwo {
    left: 51%;
  }
}
</style>
